import { EnvelopeIcon } from '@heroicons/react/24/solid';
import { RiFacebookFill, RiTwitterXFill } from '@remixicon/react';
import clsx from 'clsx';

interface SocialShareProps {
  title: string;
  className?: string;
}

function SocialShare({ title, className }: SocialShareProps) {
  const url = encodeURIComponent(window.location.href);

  return (
    <div className={clsx('flex flex-row items-center gap-1', className)}>
      <span className='text-sm font-medium'>Share On:</span>
      <div className='flex flex-row items-center gap-4'>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Share on Facebook'
        >
          <RiFacebookFill className='h-6 w-6 hover:text-hb-orange' />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?url=${url}`}
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Share on Twitter'
        >
          <RiTwitterXFill className='h-6 w-6 hover:text-hb-orange' />
        </a>
        {/* TODO: Add branding to the email share */}
        <a
          href={`mailto:?subject=${encodeURIComponent(
            `Check out this article in Hook & Barrel Magazine: ${title}`,
          )}&body=${encodeURIComponent(window.location.href)}`}
          aria-label='Share via Email'
        >
          <EnvelopeIcon className='h-6 w-6 hover:text-hb-orange' />
        </a>
      </div>
    </div>
  );
}

export default SocialShare;
